import { render, staticRenderFns } from "./OtherEntityRow.vue?vue&type=template&id=af16da7e&scoped=true&"
import script from "./OtherEntityRow.vue?vue&type=script&lang=js&"
export * from "./OtherEntityRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af16da7e",
  null
  
)

export default component.exports